import {Action} from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {PageBillingInvoiceModel} from "@services/back-office/model/pageBillingInvoiceModel";
import {BillingInvoiceModel} from "@services/back-office/model/billingInvoiceModel";
import {BillingInvoiceSearchModel} from "@services/back-office/model/billingInvoiceSearchModel";
import {PaginationModel} from "@shared/models/pagination.model";

export enum InvoicesActionTypes {
    LoadInvoices = '[Invoices] Load Invoices',
    LoadInvoicesSuccess = '[Invoices] Load Invoices Success',
    LoadInvoicesFailure = '[Invoices] Load Invoices Failure',
    EditInvoice = '[Invoice] Edit Invoice',
    EditInvoiceSuccess = '[Invoice] Edit Invoice Success',
    EditInvoiceFailure = '[Invoice] Edit Invoice Failure',
    DeleteInvoice = '[Invoice] Delete Invoice',
    DeleteInvoiceSuccess = '[Invoice] Delete Invoice Success',
    DeleteInvoiceFailure = '[Invoice] Delete Invoice Failure',
    ChangePage = '[Invoices] Change Page',
    SetInitialPagination = '[Invoices] Set Initial Pagination',
    SetFilter = '[Invoices] Set Filter',
    ClearFilter = '[Invoices] Clear Filter',
    SetInitialState = '[Invoices] Set Initial State',
}

export class LoadInvoices implements Action {
    readonly type = InvoicesActionTypes.LoadInvoices;
    constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadInvoicesSuccess implements Action {
    readonly type = InvoicesActionTypes.LoadInvoicesSuccess;
    constructor(public payload: PageBillingInvoiceModel) {}
}

export class LoadInvoicesFailure implements Action {
    readonly type = InvoicesActionTypes.LoadInvoicesFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class EditInvoice implements Action {
    readonly type = InvoicesActionTypes.EditInvoice;
    constructor(public payload: BillingInvoiceModel) {}
}

export class EditInvoiceSuccess implements Action {
    readonly type = InvoicesActionTypes.EditInvoiceSuccess;
    constructor(public payload: BillingInvoiceModel) {}
}

export class EditInvoiceFailure implements Action {
    readonly type = InvoicesActionTypes.EditInvoiceFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class DeleteInvoice implements Action {
    readonly type = InvoicesActionTypes.DeleteInvoice;
    constructor(public payload: string) {}
}

export class DeleteInvoiceSuccess implements Action {
    readonly type = InvoicesActionTypes.DeleteInvoiceSuccess;
    constructor(public payload: string) {}
}

export class DeleteInvoiceFailure implements Action {
    readonly type = InvoicesActionTypes.DeleteInvoiceFailure;
    constructor(public payload: HttpErrorResponse) {}
}

export class ChangePage implements Action {
    readonly type = InvoicesActionTypes.ChangePage;
    constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
    readonly type = InvoicesActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
    readonly type = InvoicesActionTypes.SetFilter;
    constructor(public payload: BillingInvoiceSearchModel) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
    readonly type = InvoicesActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
    readonly type = InvoicesActionTypes.SetInitialState;
}

export type InvoicesActions =
    | LoadInvoices
    | LoadInvoicesSuccess
    | LoadInvoicesFailure
    | EditInvoice
    | EditInvoiceSuccess
    | EditInvoiceFailure
    | DeleteInvoice
    | DeleteInvoiceSuccess
    | DeleteInvoiceFailure
    | ChangePage
    | SetInitialPagination
    | SetFilter
    | ClearFilter
    | SetInitialState
    ;
